import { createFileRoute } from '@tanstack/react-router';
import { governanceRouteOptions } from '../-workspaceRouteOptions';

export const Route = createFileRoute('/_authed/$orgSlug/governance')({
  ...governanceRouteOptions,
});
